package team.platforma.multiplatform_material_extension.ui.dialog.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import team.platforma.multiplatform_material_extension.ui.theme.Theme
import team.platforma.multiplatform_material_extension.ui.theme.isDark

object CommonDialogViewState {
    private val _isDialogVisible: MutableStateFlow<Boolean> = MutableStateFlow(false)
    internal val dialogVisible: StateFlow<Boolean> = _isDialogVisible

    internal fun setState(isVisible: Boolean) {
        _isDialogVisible.value = isVisible
    }
}

@Composable
fun CommonDialogViewState.isVisible(): Boolean {
    return this.dialogVisible.collectAsState().value
}

@Composable
fun rememberCommonDialogViewState(): CommonDialogViewState {
    return CommonDialogViewState
}